import withStyles from "@material-ui/core/styles/withStyles";
import { SnackbarProvider } from "notistack";
import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import "./Assets/SCSS/index.scss";
import injectClose from "./Component/Snackbar/Dismissbutton";
import Routes from "./Routes";

const styles = {
  success: {
    backgroundColor: "#fff",
    color: "#008985",
    border: "1px solid #008985",
    borderLeft: "6px solid #008985",
    fontWeight: "bold",
    zIndex: 1401,
  },
  error: {
    backgroundColor: "#fff",
    color: "#F60038 ",
    border: "1px solid #F60038",
    borderLeft: "6px solid #F60038 ",
    fontWeight: "bold",
    zIndex: 1401,
  },
  warning: {
    backgroundColor: "#fff",
    color: "#F86B07",
    border: "1px solid #F86B07",
    borderLeft: "6px solid #F86B07",
    fontWeight: "bold",
    zIndex: 1401,
  },
  info: {
    backgroundColor: "#fff",
    color: "#035EC1",
    border: "1px solid #035EC1",
    borderLeft: "6px solid #035EC1",
    fontWeight: "bold",
    zIndex: 1401,
  },
  root: {
    zIndex: "1402 !important",
  },
};

const SnackbarComponent = (props) => {
  const { classes } = props;

  return (
    <SnackbarProvider
      maxSnack={2}
      persist={false}
      preventDuplicate={true}
      autoHideDuration={5000}
      // autoHideDuration={null}
      disableWindowBlurListener={false}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      iconVariant={{
        success: "🌲 \xa0\xa0 ",
        error: "🌶 \xa0\xa0",
        warning: "⚠️ \xa0\xa0 ",
        info: "ℹ️ \xa0\xa0 ",
      }}
      transitionDuration={{ exit: 100, enter: 50 }}
      action={injectClose}
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
        containerRoot: classes.root,
      }}
    >
      <Router>
        <Switch>
          <Routes loading={"Loading...!"} />
        </Switch>
      </Router>
    </SnackbarProvider>
  );
};

export default withStyles(styles)(SnackbarComponent);
